<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls"><div class="list-view-heading__actions"><TabHeaderActions /></div></div>
        </section>
      </b-card>

      <b-card v-if="arr.report">
        <div class="app-modal-header mb-3">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">Informe de cobranza #{{ arr.report.id }}</h5>
        </div>

        <div class="app-modal-detail-list">
          <div class="app-modal-detail-list__row">
            <span class="app-modal-detail-list__label">Fecha</span>
            <span class="app-modal-detail-list__value">{{ moment(arr.report.date).format('DD MMMM YYYY') }}</span>
          </div>
          <div class="app-modal-detail-list__row" v-if="responsible">
            <span class="app-modal-detail-list__label">Responsable</span>
            <span class="app-modal-detail-list__value d-flex align-items-center">
              <b-avatar v-if="responsible.image" :src="responsible.image" size="25px" />
              <b-avatar v-else size="25px" :text="avatarFromName(responsible.name).text" :style="avatarFromName(responsible.name).style" />
              <strong class="ml-2">{{ responsible.name }}</strong>
            </span>
          </div>
          <div class="app-modal-detail-list__row" v-if="arr.report.customer">
            <span class="app-modal-detail-list__label">Cliente</span>
            <span class="app-modal-detail-list__value d-flex align-items-center">
              <b-avatar v-if="arr.report.customer.image" :src="arr.report.customer.image" size="25px" />
              <b-avatar v-else size="25px" :text="avatarFromName(arr.report.customer.name).text" :style="avatarFromName(arr.report.customer.name).style" />
              <strong class="ml-2"><span v-if="parameters.codeCustomer">({{ arr.report.customer.code }}) </span>{{ arr.report.customer.name }}</strong>
              <AppIcon v-if="!arr.report.customer.active" name="circle-fill" fill class="ml-2 text-danger" v-b-tooltip.hover title="Cliente inactivo" />
            </span>
          </div>
          <div class="app-modal-detail-list__row">
            <span class="app-modal-detail-list__label">Total</span>
            <span class="app-modal-detail-list__value app-modal-detail-list__value--info"><b>{{ formatMoney(arr.report.amounts_items) }}</b></span>
          </div>
          <div class="app-modal-detail-list__row" v-if="arr.report.observations">
            <span class="app-modal-detail-list__label">Observaciones</span>
            <span class="app-modal-detail-list__value detail-report-observations">{{ arr.report.observations }}</span>
          </div>
        </div>
      </b-card>

      <b-card v-if="arr.report">
        <div slot="header" class="app-modal-header py-1">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">Detalle de pago</h5>
        </div>
        <b-table v-if="arr.report.items && arr.report.items.length" class="app-table app-table--compact report-payment-detail-table" responsive :stacked="isMobileViewport ? 'md' : false" :items="arr.report.items" :fields="paymentFields">
          <template #cell(id)="data"><strong>{{ data.item.id }}</strong></template>
          <template #cell(type)="data">
            <span v-if="isCheck(data.item)" :id="'report-payment-detail-check-' + data.index" class="report-payment-check-info">{{ data.item.type }} <AppIcon name="info" label="Ver datos del cheque" /></span>
            <span v-else>{{ data.item.type }}</span>
            <b-popover v-if="isCheck(data.item)" :target="'report-payment-detail-check-' + data.index" triggers="hover focus click" placement="auto">
              <template #title><AppIcon name="receipt_long" class="mr-1" />Datos del cheque</template>
              <div class="report-payment-check-popover-list">
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">Número</span><span class="report-payment-check-popover-list__value">{{ checkValue(data.item, 'check_number') }}</span></div>
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">Fecha</span><span class="report-payment-check-popover-list__value">{{ formatCheckDate(data.item.check_date_movement) }}</span></div>
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">Tipo</span><span class="report-payment-check-popover-list__value">{{ checkTypeText(data.item.check_type) }}</span></div>
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">Banco</span><span class="report-payment-check-popover-list__value">{{ checkValue(data.item, 'check_bank') }}</span></div>
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">CUIT</span><span class="report-payment-check-popover-list__value">{{ checkValue(data.item, 'check_cuit') }}</span></div>
                <div class="report-payment-check-popover-list__row"><span class="report-payment-check-popover-list__label">Observaciones</span><span class="report-payment-check-popover-list__value">{{ checkValue(data.item, 'check_observations') }}</span></div>
              </div>
            </b-popover>
          </template>
          <template #cell(amount)="data"><span :class="data.item.type === 'Nota de Débito' ? 'text-danger' : 'text-success'">{{ signedMoney(data.item) }}</span></template>
        </b-table>
        <EmptyState v-else icon="money" title="Sin medios de pago" description="Este informe no tiene detalle de pagos cargado." />
      </b-card>

      <b-card v-else-if="!isBusy"><EmptyState icon="reports" title="No se encontró el informe" description="El registro no está disponible o fue eliminado." /></b-card>

      <b-card body-class="py-2">
        <section class="list-view-footer"><b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="arrow_back" class="mr-1" />Volver</b-button></section>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import serviceAPI from './services'
import Error from '@/handler/error'
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import Funciones from '@/handler/funciones'
import Param from '@/config/parameters'
import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
import EmptyState from '@/components/inc/state/EmptyState'
import moment from 'moment'

export default {
  components: { TabHeaderActions, EmptyState },
  data: () => ({
    access: { module_id: Modules.INFORME_COBRANZAS, profile_id: Profiles.PERSONAL, view_reference: 'detailReport', elements: {} },
    parameters: { codeCustomer: Helper.hasParametersAccess(Param.P2) },
    reportID: 0,
    isBusy: true,
    isMobileViewport: false,
    fieldsPayment: [
      { key: 'id', label: 'ID', desktopClass: 'text-left' },
      { key: 'type', label: 'Medio', desktopClass: 'text-left' },
      { key: 'amount', label: 'Importe', desktopClass: 'text-right' },
    ],
    arr: { report: null },
  }),
  computed: {
    responsible () {
      if (!this.arr.report) return null
      return this.arr.report.staff_id ? this.arr.report.staff : (this.arr.report.seller && this.arr.report.seller.staff)
    },
    paymentFields () {
      return this.fieldsPayment.map(field => Object.assign({}, field, { class: 'align-middle ' + this.alignClass(field.desktopClass) }))
    },
  },
  created () { Helper.hasAccessView(this.access) },
  mounted () {
    this.reportID = this.$route.params.reportID
    this.mobileMql = window.matchMedia('(max-width: 767.98px)')
    this.isMobileViewport = this.mobileMql.matches
    this.mobileMql.addEventListener('change', this.updateMobileViewport)
    this.load()
  },
  beforeDestroy () { if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport) },
  methods: {
    moment,
    updateMobileViewport (event) { this.isMobileViewport = event.matches },
    alignClass (desktopClass) { return this.isMobileViewport ? 'text-left' : desktopClass },
    avatarFromName (name) { return Funciones.avatarFromName(name) },
    formatMoney (value) { return Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(value || 0) },
    signedMoney (item) { return (item.type === 'Nota de Débito' ? '- ' : '') + this.formatMoney(item.amount) },
    isCheck (item) { return String(item.type || '').toLowerCase() === 'cheque' },
    checkValue (item, field) { return item[field] || '-' },
    checkTypeText (type) { return ({ propios: 'Propios', de_terceros: 'De terceros' })[type] || type || '-' },
    formatCheckDate (date) { return date ? moment(date).format('DD/MM/YYYY') : '-' },
    validation () {
      const seller = Helper.getSeller()
      if (seller && this.arr.report.sellers_id !== seller.id) this.$router.push({ name: 'Error403' })
    },
    load () {
      serviceAPI.mostrar(this.reportID)
        .then((response) => {
          this.arr.report = response.data
          this.isBusy = false
          this.validation()
        })
        .catch((error) => {
          this.isBusy = false
          this.$awn.alert(Error.showError(error))
        })
    },
  },
}
</script>

<style>
.detail-report-observations { white-space: pre-line; }
.report-payment-check-info { cursor: help; }
.report-payment-check-popover-list__row { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; padding: 4px 0; }
.report-payment-check-popover-list__row + .report-payment-check-popover-list__row { border-top: 1px solid var(--app-color-border); }
.report-payment-check-popover-list__label { flex: 1 1 auto; min-width: 0; color: var(--app-color-text-muted); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); }
.report-payment-check-popover-list__value { flex: 0 0 auto; max-width: 170px; overflow-wrap: anywhere; text-align: right; color: var(--app-color-text); font-weight: var(--app-font-semibold); }
@media (max-width: 767.98px) {
  .report-payment-detail-table.app-table.b-table-stacked-md > tbody > tr > td { text-align: left !important; }
}
</style>
